import { render, staticRenderFns } from "./ToArchive.vue?vue&type=template&id=6b3a962d&scoped=true&"
import script from "./ToArchive.vue?vue&type=script&lang=js&"
export * from "./ToArchive.vue?vue&type=script&lang=js&"
import style0 from "./ToArchive.vue?vue&type=style&index=0&id=6b3a962d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a962d",
  null
  
)

export default component.exports